import { apiCall } from '../../../Middleware/API/apiRequest';
import { getTokensFromStorage } from '../../../Utils/Auth/AuthToken';
import { normalizeTagList } from '@/Modules/Core/Components/Tags/tagUtils';

const { accessToken } = getTokensFromStorage();

const isResponseSuccessful = (response) =>
  response?.isSuccess === true ||
  response?.success === true ||
  response?.status?.code === 0;

const apiRequest = async (request) => {
  const headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  };

  try {
    const response = await apiCall({
      ...request,
      headers,
      accessToken,
    });

    if (!response) {
      return {
        isSuccess: false,
        message: 'No response returned from the server.',
      };
    }

    return response;
  } catch (error) {
    return {
      isSuccess: false,
      message: error?.message || 'Request failed.',
    };
  }
};

const getTagCollectionFromResponse = (response) => {
  const payload = response?.payload;

  return (
    response?.data ??
    payload?.tags ??
    payload?.items ??
    payload?.data ??
    payload ??
    []
  );
};

const tagCatalogRoutes = ['/rollouts/tags', '/rollout-tags', '/tags'];

const rolloutTagRoutes = (rolloutName) => {
  const encodedName = encodeURIComponent(String(rolloutName ?? '').trim());

  return [
    `/rollouts/${encodedName}/tags`,
    `/rollouts/tags/${encodedName}`,
  ];
};

export const searchRolloutTags = async ({ search = '' } = {}) => {
  const query = String(search ?? '').trim();
  const searchParams = new URLSearchParams();

  if (query) {
    searchParams.set('search', query);
  }

  let lastFailure = null;

  for (const route of tagCatalogRoutes) {
    const response = await apiRequest({
      url: searchParams.size > 0 ? `${route}?${searchParams.toString()}` : route,
      method: 'GET',
    });
    const tags = normalizeTagList(getTagCollectionFromResponse(response));

    if (isResponseSuccessful(response) || tags.length > 0) {
      return {
        isSuccess: true,
        tags,
      };
    }

    lastFailure = response;
  }

  return {
    isSuccess: false,
    tags: [],
    message: lastFailure?.message || 'Unable to load tags.',
  };
};

export const updateRolloutTags = async ({ rolloutName, tags = [] }) => {
  const normalizedName = String(rolloutName ?? '').trim();

  if (!normalizedName) {
    return {
      isSuccess: false,
      message: 'A rollout name is required to update tags.',
    };
  }

  const payload = {
    tags: normalizeTagList(tags).map((tag) => tag.label),
  };
  let lastFailure = null;

  for (const route of rolloutTagRoutes(normalizedName)) {
    for (const method of ['PUT', 'POST']) {
      const response = await apiRequest({
        url: route,
        method,
        body: JSON.stringify(payload),
      });

      if (isResponseSuccessful(response)) {
        return {
          isSuccess: true,
          payload: response?.payload,
        };
      }

      lastFailure = response;
    }
  }

  return {
    isSuccess: false,
    message: lastFailure?.message || 'Unable to update rollout tags.',
  };
};
